import React, { PropsWithChildren, useEffect, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { showErrorToast } from "../../../atoms/Utlis/Toast";
import { useWhatsAppAccess } from "../../../../hooks/useWhatsAppAccess";

import { ErrorBoundary } from "../../../atoms/ErrorBoundary";

type WhatsAppAccessGateProps = PropsWithChildren<{
  fallbackPath?: string;
}>;

const WhatsAppAccessGate: React.FC<WhatsAppAccessGateProps> = ({
  children,
  fallbackPath = "/dashboard/whatsapp",
}) => {
  const location = useLocation();
  const { loading, canAccess, accessMessage } = useWhatsAppAccess();
  const hasShownError = useRef(false);

  useEffect(() => {
    if (loading) {
      hasShownError.current = false;
      return;
    }

    if (!canAccess && accessMessage && !hasShownError.current) {
      hasShownError.current = true;
      showErrorToast(accessMessage);
    }
  }, [loading, canAccess, accessMessage]);

  if (loading) {
    return null;
  }

  if (!canAccess) {
    return <Navigate replace to={fallbackPath} state={{ from: location.pathname }} />;
  }

  return (
    <ErrorBoundary>
      {children}
    </ErrorBoundary>
  );
};

export default WhatsAppAccessGate;